export default __webpack_public_path__ + "static/media/tarjeta-de-credito.3e977190.svg";